import script from "./Alerts.vue?vue&type=script&setup=true&lang=js"
export * from "./Alerts.vue?vue&type=script&setup=true&lang=js"

import "./Alerts.vue?vue&type=style&index=0&id=017eeb7a&lang=css"

const __exports__ = script;

export default __exports__